export default __webpack_public_path__ + "static/media/backoffice  Inactive.aead8e08.svg";